import { render, staticRenderFns } from "./entrancePermission.vue?vue&type=template&id=233e91ab&scoped=true"
import script from "./entrancePermission.vue?vue&type=script&lang=js"
export * from "./entrancePermission.vue?vue&type=script&lang=js"
import style0 from "./entrancePermission.vue?vue&type=style&index=0&id=233e91ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e91ab",
  null
  
)

export default component.exports